<template>
  <div>
    <z-header :title="title" :actions="actions"></z-header>
    <div>Processando...</div>
  </div>
</template>

<script>
import ZHeader from "../../layout/Header";
import fleetUser from "../../services/fleetUser";
import {formatDocument} from "../../filters/document";

export default {
  data() {
    return {
      title: "Remover motorista",
      id: null,
      entry: {},
      isLoading: false,
      actions: []
    };
  },
  mounted() {
    this.id = this.$route.params.id;
    this.remove();
  },
  methods: {
    async remove() {
      try {
        this.entry = await fleetUser.get(this.id);

        this.$buefy.dialog.confirm({
          message: `Você confirma a exclusão do motorista <strong>${formatDocument(this.entry.document)} ${this.entry.name}</strong>?`,
          onConfirm: async () => {
            await fleetUser.delete(this.id);

            this.$router.push({
              name: "fleetUser"
            });
          },
          onCancel: async () => {
            this.$router.push({
              name: "fleetUser/editar",
              params: { id: this.id }
            });
          }
        });
      } catch (error) {
        this.$buefy.toast.open({
          message: "Erro ao remover os veículo",
          type: "is-danger"
        });
      }
    }
  },
  components: {
    ZHeader
  }
};
</script>

<style lang="scss"></style>
